import { appSettings } from '@/shared/consts/appSettings'
import {
  hasWebViewCookiesPermitted,
  isWebView
} from '@/utils/helpers/webViewHelper'
import * as TagManager from 'react-gtm-module'

export const buildGtmService = () => {
  if (isWebView() && !hasWebViewCookiesPermitted()) return

  TagManager.initialize({
    gtmId: appSettings.gtmId
  })
}

export const sendEventGTM = (event: string, data = {}) => {
  if (isWebView() && !hasWebViewCookiesPermitted()) {
    return
  }

  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data
    }
  })
}

export const buildParamsGTM = (params: any) => {
  if (!params) return

  const paramsMap = {
    utm_id: 'campaignID',
    utm_source: 'campaignSource',
    utm_medium: 'campaignMedium',
    utm_campaign: 'campaignName',
    utm_term: 'campaignTerm',
    utm_content: 'campaignContent',
    utm_keyword: 'campaignKeyword',
    idCommunication: 'idCommunication'
  }

  const paramSearch = {}

  new URLSearchParams(params).forEach((value, key) => {
    const mappedKey = paramsMap[key]
    if (mappedKey) {
      paramSearch[mappedKey] = value
    }
  })

  return paramSearch
}
